export var DocsBlockItemVariantLayoutColumnResizing;
(function (DocsBlockItemVariantLayoutColumnResizing) {
    /** Will fill all available space for the column */
    DocsBlockItemVariantLayoutColumnResizing["fill"] = "Fill";
    /** Will hug content inside the column */
    DocsBlockItemVariantLayoutColumnResizing["hug"] = "Hug";
})(DocsBlockItemVariantLayoutColumnResizing || (DocsBlockItemVariantLayoutColumnResizing = {}));
